import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/browser';

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: 'https://6f98770a8d704f01ae19a67122535d48@tracker.back-bone.nl/19',
  tracesSampleRate: 0.01,
});

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
